'use strict';

namespace Core {

    class SelectedCarhireSummary {

        carhire: any;

        public details :any;
        public show :boolean = false;

        constructor(
            private $scope: ng.IScope
        ) {

            let stop = this.$scope.$watch('scs.carhire', v => {
                if (v) {
                    this.init(v);
                    stop();
                }
            });

        }

        private init(carhire :any) :void {
            this.details = carhire.Details.HireDetails;
            this.show = true;
        }

    }

    angular
        .module('core')
        .directive('selectedCarhireSummary', (): ng.IDirective => {

        return {
            scope: {},
            controller: SelectedCarhireSummary,
            controllerAs: 'scs',
            replace: true,
            bindToController: {
                carhire: '=',
                titleText: '@'
            },
            templateUrl: 'partials/home/directivetemplate?type=SelectedCarHireSummary'
        };

    });

}
